export const MIN_WIDTH = 300;
export const MAX_WIDTH = 410;
